import gql from 'graphql-tag';

export default gql`
	mutation ContainerPortFavoriteDelete($id: ID!) {
		containerPortFavoriteDelete(_id: $id) {
			succeed
		}
	}
`;
